
import React, { Component } from 'react'
 import MapContainer from '../components/mapcontainer'

export default class Chart extends Component {
    /*
        This is a connecting component for connecting Dashboard to Mapcontainer. 
    */
    constructor(props){
        super(props);

        this.state = {
            
        }

    }

    // subscribe to the realtime database after the component is mounted. 
    componentDidMount(){

    }


    render(){
        return(
            <div  className= "column">
                <div id = "mapContainer" className = "ui raised segment" >
                    {/* <Label attached='top' inverted content={this.props.chartTitle}/> */}
                    <MapContainer  nodeInfo ={this.props.nodeInfo} average = {this.props.average}/>

                </div>
            </div>

        );
    }

}



// WEBPACK FOOTER //
// ./src/components/chart.js